var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRightPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.8764 12.1132C11.4258 12.5448 11.4258 13.2446 11.8764 13.6763C12.327 14.1079 13.0576 14.1079 13.5082 13.6763L19.662 7.78154C19.8873 7.56572 20 7.28286 20 7C20 6.85014 19.9689 6.70724 19.9124 6.57692C19.8561 6.44656 19.7727 6.32443 19.662 6.21846L13.5082 0.323725C13.0576 -0.107908 12.327 -0.107908 11.8764 0.323725C11.4258 0.755358 11.4258 1.45517 11.8764 1.8868L16.0605 5.89474L1.15385 5.89474C0.516593 5.89474 -6.65324e-07 6.38958 -6.11959e-07 7C-5.58595e-07 7.61042 0.516593 8.10527 1.15385 8.10527L16.0605 8.10526L11.8764 12.1132Z",
    fill: "#0095FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightPrimary);
export default __webpack_public_path__ + "static/media/iconArrowRightPrimary.6d85dc3acd3fb1ce9091d53499638b07.svg";
export { ForwardRef as ReactComponent };